package com.github.jangalinski.tabweb.badge

/**
 * Enumerates the supported Tabweb shapes for a [Badge].
 */
enum class BadgeShape {
  /**
   * Uses Tabweb's default badge corners.
   */
  DEFAULT,

  /**
   * Uses fully rounded Tabweb badge ends.
   */
  PILL,
}
